import { liveRolesDirectoryClient } from "./rolesDirectory.live";
import type { RolesDirectoryClient } from "./rolesDirectory.types";

export const rolesDirectoryClient: RolesDirectoryClient = liveRolesDirectoryClient;
